module.exports = __webpack_public_path__ + "static/screen3-d0ded77c4a5e886c02384e58c1783ee9.png";